import * as React from "react";
import { useQuery } from "@tanstack/react-query";
import { Extractors } from "@graylog/server-api";
import { Spinner } from "components/common";
import { Table } from "components/bootstrap";
import { defaultOnError } from "util/conditional/onError";
const fetchExtractors = (inputId) => Extractors.list(inputId);
const useInputExtractors = (inputId) => useQuery({
  queryKey: ["input", inputId, "extractors"],
  queryFn: () => defaultOnError(fetchExtractors(inputId), "Loading extractors failed with status", "Could not load extractors")
});
const ExtractorsSection = ({ input }) => {
  var _a;
  const { data, isInitialLoading, isError } = useInputExtractors(input.id);
  if (isInitialLoading) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  if (isError) {
    return /* @__PURE__ */ React.createElement("p", null, "Could not load extractors.");
  }
  const extractors = (_a = data == null ? void 0 : data.extractors) != null ? _a : [];
  if (extractors.length === 0) {
    return /* @__PURE__ */ React.createElement("p", null, "This input has no configured extractors.");
  }
  return /* @__PURE__ */ React.createElement(Table, { bordered: true, condensed: true }, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "Title"), /* @__PURE__ */ React.createElement("th", null, "Type"), /* @__PURE__ */ React.createElement("th", null, "Source field"), /* @__PURE__ */ React.createElement("th", null, "Target field"))), /* @__PURE__ */ React.createElement("tbody", null, extractors.map((extractor) => /* @__PURE__ */ React.createElement("tr", { key: extractor.id }, /* @__PURE__ */ React.createElement("td", null, extractor.title), /* @__PURE__ */ React.createElement("td", null, extractor.type), /* @__PURE__ */ React.createElement("td", null, extractor.source_field), /* @__PURE__ */ React.createElement("td", null, extractor.target_field)))));
};
export default ExtractorsSection;
